import { render, staticRenderFns } from "./TaskWorkflowUpdated.vue?vue&type=template&id=2015aaf2&scoped=true"
import script from "./TaskWorkflowUpdated.vue?vue&type=script&lang=js"
export * from "./TaskWorkflowUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015aaf2",
  null
  
)

export default component.exports